import { z } from 'zod';
/**
 * `Document.type` — ce qu'une pièce jointe **est**
 * ([M20](../../../../docs/MODELE-DONNEES.md#m20)).
 *
 * ⚠️ **Indépendant de `non_compliant`, et c'est tout l'objet des deux colonnes.** Les filtres de
 * pièces du prototype (`Toutes / Schéma / Non conformes / Regards / Vidéos`) croisent deux axes :
 * une photo de regard peut être non conforme ou non. Ranger `non_compliant` dans ce type-ci
 * interdirait de dire laquelle.
 *
 * ⚠️ **`video` est un type, pas un format.** M11 pose que photos et vidéos ont le même
 * traitement et que « seul `type` les distingue » ; `format` (`JPEG` | `MP4`) dit comment les
 * octets sont encodés, pas ce que la pièce montre.
 *
 * ⚠️ **`schematic` et non `diagram`, et c'est un seul mot du transport au stockage.** Le diagramme
 * écrivait `diagram` ; la tablette, elle, transmet l'image rendue du schéma de réseau sous le type
 * `schematic` (`submittedMediumSchema`). Deux mots pour la même pièce auraient obligé chaque
 * écriture à traduire, et la première qui aurait oublié serait passée sans que rien ne le signale.
 * Arbitré le 18/09/2026, **table vide** : le coût était nul ce jour-là et ne l'aurait plus jamais
 * été. ⚠️ La liste de vocabulaire `diagram_element` garde son nom — elle désigne les **éléments**
 * qu'on dessine, pas le dessin.
 *
 * `report` (le rapport PDF, M11) naît côté serveur ; `signature` vient du terrain, désignée par
 * `signatureMediaId` dans la charge utile.
 *
 * ⚠️ **`schematic_photo` n'est pas `schematic`** (#397) : c'est la photo d'un schéma fait sur
 * papier, prise par l'agent comme une autre photo. Le rapport l'imprime dans la section du schéma
 * — à sa place quand rien n'a été dessiné, à côté du dessin sinon —, jamais dans l'annexe. Ajoutée
 * en dernier : l'enum Postgres ne s'étend qu'en queue sans réécrire l'ordre des valeurs.
 */
export const DOCUMENT_TYPES = [
    'schematic',
    'manhole',
    'stormwater',
    'view',
    'video',
    'report',
    'signature',
    'schematic_photo',
];
export const documentTypeSchema = z.enum(DOCUMENT_TYPES);
//# sourceMappingURL=document.js.map